"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.TimePicker = void 0;
var react_1 = __importDefault(require("react"));
var TimePicker_1 = require("@mui/x-date-pickers/TimePicker");
var LocalizationProvider_1 = require("@mui/x-date-pickers/LocalizationProvider");
var AdapterMoment_1 = require("@mui/x-date-pickers/AdapterMoment");
var material_1 = require("@mui/material");
/**
 * time picker that is compatible with safari and firefox.
 * pass in initial values of new Date() to avoid keyboard input issues.
 *
 * @component TimePicker
 * @example
 * return (
 *   <TimePicker
 *     label="Pick Time"
 *     value={formik.values.timefield}
 *     onChange={(time: Date) => {
 *       formik.setFieldValue('timefield', time)
 *     }}
 *     disabled={!isChecked}
 *   />
 * )
 *
 * @param {date} value value of the picker
 * @param {function} onChange function for what happens on change
 * @param {string} label label of the timepicker
 * @param {boolean} disabled is the time picker disabled
 */
var TimePicker = function (props) {
    var value = props.value, onChange = props.onChange, label = props.label, disabled = props.disabled;
    return (react_1.default.createElement(LocalizationProvider_1.LocalizationProvider, { dateAdapter: AdapterMoment_1.AdapterMoment },
        react_1.default.createElement(TimePicker_1.TimePicker, { mask: "__:__ _M", value: value, onChange: onChange, disabled: disabled, label: label, renderInput: function (params) { return react_1.default.createElement(material_1.TextField, __assign({}, params)); } })));
};
exports.TimePicker = TimePicker;
exports.default = exports.TimePicker;
